<template>
  <div class="data-explorer">
    <div class="explorer-header">
      <h3><i class="fas fa-search"></i> Data Explorer</h3>
      <p>Explore and analyze test data generated in the system.</p>
    </div>
    
    <div class="coming-soon">
      <div class="icon-wrapper">
        <i class="fas fa-tools"></i>
      </div>
      <h4>Feature in Development</h4>
      <p>The data explorer will soon be available to:</p>
      <ul>
        <li>Visualize score distributions</li>
        <li>Analyze psychometric metrics</li>
        <li>Compare different datasets</li>
        <li>Export detailed reports</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
// Placeholder component for data explorer
</script>

<style scoped>
.data-explorer {
  padding: 40px;
  text-align: center;
}

.explorer-header {
  margin-bottom: 50px;
}

.explorer-header h3 {
  color: #2c3e50;
  margin-bottom: 10px;
  font-size: 1.5rem;
}

.explorer-header p {
  color: #6c757d;
  font-size: 1rem;
}

.coming-soon {
  max-width: 500px;
  margin: 0 auto;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 20px;
  border: 2px dashed #dee2e6;
}

.icon-wrapper {
  margin-bottom: 20px;
}

.icon-wrapper i {
  font-size: 3rem;
  color: #6c757d;
}

.coming-soon h4 {
  color: #495057;
  margin-bottom: 15px;
}

.coming-soon p {
  color: #6c757d;
  margin-bottom: 20px;
}

.coming-soon ul {
  text-align: left;
  color: #6c757d;
  list-style: none;
  padding: 0;
}

.coming-soon li {
  padding: 5px 0;
  position: relative;
  padding-left: 20px;
}

.coming-soon li::before {
  content: '•';
  color: #007bff;
  position: absolute;
  left: 0;
  font-weight: bold;
}
</style>